<template>
  <v-container>
    <!-- <TitleH1 text="Categorias" /> -->
    <div class="categoryList">
      <ProdutosdoPedido v-for="produto in listadeprodutos" :key="produto.idcategoriaprod" 
        :produto="produto" :idcategoriaprodcd="idcategoriaprodcd" :idsubcategoriaprodcd="idsubcategoriaprodcd"
        :idpdv="idpdv"
        @retirarProdutosdoPedido="(produto)=>retirarProdutosdoPedido(produto)"
       />
    </div>
  </v-container>
</template>

<script>
  // import TitleH1 from './TitleH1.vue'
  import ProdutosdoPedido from './ProdutosdoPedido.vue'
  export default {
    name: 'ProdutoListaCarrinho',
    props:['idcategoriaprodcd','idsubcategoriaprodcd','idpdv','listadeprodutos'],
    components:{
      // TitleH1,
      ProdutosdoPedido
    },
    data: () => ({
      // listadeprodutos:[]
    }),

    methods:{

      retirarProdutosdoPedido(produto){
        this.$emit('retirarProdutosdoPedido',produto)
      }

    },

    mounted(){
      this.getProdutos()
    }



  }
</script>

<style scoped>
    .categoryList{
      /* background-color:green; */
      display:flex;
      flex-wrap: wrap;
      justify-content: center;
      width:100%;
      padding:0px!important;
    }
</style>
